import classNames from "classnames";
import React from "react";

import {
  flexClass,
  flexGrowClass,
  flexJustifyClass,
  IStyleFlexGrow,
  IStyleFlexJustify,
  IStyleWidth,
  widthClass,
} from "./../../Style";

interface Styles extends IStyleWidth, IStyleFlexGrow, IStyleFlexJustify {}

export interface IFormElementProps extends Partial<Styles> {
  className?: string;
}

export function withFormElement<P = {}>(Component: React.ComponentType<P>) {
  type Props = P & IFormElementProps;

  return class FormElement extends React.PureComponent<Props> {
    render() {
      const { className, width, grow, justify, ...rest } = this.props as any;

      const classes = classNames(
        widthClass(width),
        flexClass(true),
        flexGrowClass(grow),
        flexJustifyClass(justify),
        className,
      );

      return <Component className={classes} {...rest} />;
    }
  };
}
